module.exports = __webpack_public_path__ + "static/schedules-c96e5e91f971c89c5cab841ffb3bc270.jpg";